exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".name-candidate{\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n.vue-form-wizard{\n  /* position: absolute !important; */\n  top: 50px !important;\n  width: 100%\n}\n", ""]);

// exports
